import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { GlobalErrorHandlerInterceptor } from './interceptors/global-error-handler.interceptor';
import { GlobalSpinnerInterceptor } from './interceptors/global-spinner.interceptor';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      preventDuplicates: true,
      positionClass: 'toast-top-right',
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalErrorHandlerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalSpinnerInterceptor, multi: true },
  ],
})
export class CoreModule { }
